import { useTranslation } from 'react-i18next'
import { useChangeLanguageMutation } from 'src/redux/api'

// The interface language, shared by the sidebar picker, the phone profile
// menu and the footer: i18next switches the page, localStorage remembers it
// and, for a signed-in user, so does the account (a guest has none to write).
export const useLanguage = () => {
  const { i18n } = useTranslation()
  const [changeLanguage] = useChangeLanguageMutation()

  const setLanguage = (value: string, { account = true }: { account?: boolean } = {}) => {
    i18n.changeLanguage(value)
    if (account) changeLanguage({ language: value })
    try {
      localStorage.setItem('language', value)
    } catch {
      // storage blocked: the account (if any) still keeps the choice
    }
  }

  return { language: (i18n.resolvedLanguage || i18n.language || 'uk').slice(0, 2), setLanguage }
}
